
import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { GlobalComponent } from 'src/app/global/global.component';
import { DataStateChangeEventArgs, FilterSettingsModel, IFilter, ToolbarItems } from '@syncfusion/ej2-grids'
import { functionpermission, GetListBO, SupportPlannerBO, WhereCondition } from './supportplanner.model';
import { takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { supportService } from './supportplanner.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { GetHTTPService } from './supportplannerdata.service';
import { CommonHttpService } from 'src/app/common.service';
import { GeneralService } from 'src/app/service/general.service';
import { columnWidth } from '../list/list.model';


@Component({
  selector: 'app-supportplanner',
  templateUrl: './supportplanner.component.html',
  styleUrls: ['./supportplanner.component.scss']
})
export class SupportplannerComponent implements OnInit {
  ModelType: string;
  @ViewChild('grid') public grid: GridComponent;
  //fp: functionpermission;
  valuechange: any = [];
  CaseForm: FormGroup;
  form: FormGroup
  isSaveorUpdateBoolean:boolean=false;
  initialPage: object;
  filterOptions: FilterSettingsModel;
  public toolbar: ToolbarItems[];
  filter: IFilter;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  support: SupportPlannerBO = new SupportPlannerBO();
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
  arraycol: any = [];
  ColumnArray: columnWidth[]
  SupportSendBO: GetListBO = new GetListBO();
  conditionlist: WhereCondition[] = [];
  conditionData: WhereCondition = new WhereCondition();

  public data: Observable<DataStateChangeEventArgs>;
  constructor(fb: FormBuilder, public global: GlobalComponent, @Inject(GetHTTPService) public gethttp: GetHTTPService,
    private cdr: ChangeDetectorRef,
    public general: GeneralService, public commonhttp: CommonHttpService, public toastrService: ToastrService,
    public supportser: supportService) {
    this.global.checkforlogout();

    this.data = gethttp;

    this.form = fb.group({

      name: [' '],
      street: [''],
      state: [''],
      email: ['', Validators.email],
      city: [''],
      zip: ['',],
      phone: ['',],
      fax: ['',],
    })

  }

  get email() {
    return this.form.get('email');
  }

  get zip() {
    return this.form.get('zip');
  }

  get phone() {
    return this.form.get('phone');
  }
  get fax() {
    return this.form.get('fax');
  }

  private onDestroy$: Subject<void> = new Subject<void>();
  stateList: any = [];

  agencyid_boll = false
  fp: functionpermission = new functionpermission()

  ngOnInit(): void {
    if
      (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }
    if (this.global.globalAgencyId) {
      this.agencyid_boll = true

    }
    else {
      this.agencyid_boll = false

    }
    this.toolbar = ['ColumnChooser'];

    this.getsuppoert();
    this.commonhttp.getJSON().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;



    });


    this.filterOptions = { type: 'Menu' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.getpermission()
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "Support Planner");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.supportser.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data != null) {
          this.fp = data;

        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }



  /////////////////////////////////////////////////////////
  CaseCreateupdate(type: string) {
    console.log(this.isSaveorUpdateBoolean,"isSaveorUpdateBoolean", this.form.invalid,"this.form",this.support.name)
    if (type == 'new') {
      this.ModelType = 'new';
      this.support = new SupportPlannerBO();
      this.form.reset();


    }
    else {

      this.ModelType = 'edit';
    }

  }


  openDialog() {
    if (this.valuechange.Name > 1 || this.valuechange.Street > 1 ||
      this.valuechange.State > 1 || this.valuechange.City > 1 || this.valuechange.Zip > 1 ||
      this.valuechange.Phone || this.valuechange.Fax) {
      document.getElementById('cancelcasemanmodal').click();
    }
    else {
      document.getElementById('opencasemanModal1').click();
    }

  }


  valueschanges() {
    this.valuechange = {
      Name: 0,
      Phone: 0,
      Street: 0,
      City: 0,
      State: 0,
      Zip: 0,
      Fax: 0,
    }
  }
  checkpopup(value) {
    if (value == "name") {
      this.valuechange.Name++;
    }
    if (value == "phone") {
      this.valuechange.Phone++;
    }
    if (value == "street") {
      this.valuechange.Street++;
    }
    if (value == "city") {
      this.valuechange.City++;
    }
    if (value == "state") {
      this.valuechange.State++;
    }
    if (value == "zip") {
      this.valuechange.Zip++;
    }

    if (value == "fax") {
      this.valuechange.Fax++;
    }
  }

  add(type: string) {
    this.isSaveorUpdateBoolean=true;
    if (this.support.id == '00000000-0000-0000-0000-000000000000') {
      var saveList: SupportPlannerBO = new SupportPlannerBO();
      saveList= JSON.parse(JSON.stringify(this.support));
      this.supportser.save(saveList).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.isSaveorUpdateBoolean=false;
        this.toastrService.success("saved  Successfully", "support planner saved");
        document.getElementById("opencasemanModal1").click();

        this.getsuppoert();
      },
        err => {
          this.isSaveorUpdateBoolean=false;
          console.log(err);
          this.toastrService.error(err);

        });
    }
    else {

      this.supportser.save(this.support).subscribe((data: any) => {
        this.isSaveorUpdateBoolean=false;
        this.toastrService.success("update  Successfully", "support planner Updated ");
        document.getElementById("opencasemanModal1").click();

        this.getsuppoert();
      },
        err => {
        this.isSaveorUpdateBoolean=false;  
        console.log(err)        
          this.toastrService.error(err);


        });
    }


  }


  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();

    }

  }

  PhoneFormat(value) {
    if (value == 'phone') {
      this.support.phone = this.general.converPhoneGoogleLib(this.support.phone);
    }

  }

  PhoneFormat1(value) {
    if (value == 'fax') {
      this.support.fax = (this.support.fax != '' && this.support.fax != undefined && this.support.fax != null) ? this.general.converPhoneGoogleLib(this.support.fax) : null;
    }
  }

  // /////////////////////////////////////////////////////////////////////////////////
  DemographicPhoneFormat(value) {

    if (value == 'phone') {
      this.support.phone = this.general.reconverPhoneGoogleLib(this.support.phone);
    }
  }
  DemographicPhoneFormat1(value) {
    if (value == 'fax') {
      this.support.fax = this.general.reconverPhoneGoogleLib(this.support.fax);
    }

  }

  public ContactId: string;

  setDeleteId(value) {
    this.ContactId = value;
  }


  Delete() {
    let param = new URLSearchParams()
    param.append("Id", this.ContactId)
    this.supportser.delete(param).subscribe((_data: any) => {
      this.toastrService.success("support planner has been deleted successfully", "support planner deleted");
      document.getElementById("openModal2").click();
      this.getsuppoert();

    },
      err => {
        this.toastrService.error(err.error);
      })

  }

  selectedContactdetails(detail: SupportPlannerBO) {
    this.support = JSON.parse(JSON.stringify(detail));
  }

  getlist: GetListBO = new GetListBO();
  getsuppoert() {
    this.gethttp.execute(this.SupportSendBO);
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
    })
  }

  editsupport(data) {
    this.support = JSON.parse(JSON.stringify(data));
    this.form.patchValue(data);
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onResize(args) {
    const column = this.grid.getColumnByField(args.column.field)
    column.width = args.column.width;

    this.ColumnArray.forEach(element => {
      if (element.column == column.headerText) {
        element.width = parseInt(column.width.toString());
      }

    });

  }
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  public onActionComplete(args) {
    this.SupportSendBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.SupportSendBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }

  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  type: string = "";
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.SupportSendBO.orderColumn = state.sorted[0].name;
        this.SupportSendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.SupportSendBO.field = state.action.currentFilterObject.field;
      this.SupportSendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.SupportSendBO.operator = state.action.currentFilterObject.operator;
      this.SupportSendBO.value = state.action.currentFilterObject.value;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.SupportSendBO.field = "name";
        this.SupportSendBO.matchCase = false;
        this.SupportSendBO.operator = "startswith";
        this.SupportSendBO.value = "";
      }
    }
    this.getsuppoert();
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].supportplanner.Pagesize != state.take) {
          this.arraycol[0].supportplanner.Pagesize = state.take

        }

      }
    }
  }
  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }


  refresh() {
    this.getsuppoert();
  }

}
